import { Box } from '@mui/material';
import { LoadingDots, MotionText } from '@shared/atoms';
import React from 'react';
import { useHistory } from 'react-router';
import { SystemButton } from '../SystemButton/SystemButton';

export const LoadingBackdrop = ({
  text,
  goBackEnabled = false,
}: {
  text: string;
  goBackEnabled?: boolean;
}) => {
  const history = useHistory();

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        padding: '20px',
        cursor: 'default',
      }}
    >
      <Box
        sx={{
          backgroundColor: 'white',
          padding: 3,
          borderRadius: 2,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <LoadingDots isHapstarLoading />
        <MotionText as="p" text={text} style={{ textAlign: 'center' }} />

        {goBackEnabled && (
          <Box sx={{ marginTop: '14px' }}>
            <SystemButton onClick={() => history.push('/')} size="medium">
              Go back
            </SystemButton>
          </Box>
        )}
      </Box>
    </Box>
  );
};

LoadingBackdrop.defaultProps = {
  goBackEnabled: false,
};
